module.exports = __webpack_public_path__ + "img/Aston.227d0270.jpg";